import { useMutation, useQuery } from "@tanstack/react-query";
import queryKey from "../../enumerations/queryKey";
import { apiGetRedEnvelopeEligibility, apiPostRedEnvelope } from "./service";

export const usePutRedEnvelope = (options) => {
  return useMutation(
    () =>
      apiPostRedEnvelope().then((res) => {
        return res.data.data;
      }),
    {
      ...options,
    },
  );
};

export const useGetEligibleRedEnvelope = (options) => {
  return useQuery(
    [queryKey.RED_ENVELOPE],
    () => apiGetRedEnvelopeEligibility().then((res) => res.data.data),
    {
      staleTime: 60 * (60 * 1000), //60mins
      cacheTime: 60 * (60 * 1000), //60mins
      ...options,
    },
  );
};
